import { jsxs as d, Fragment as j, jsx as f } from "react/jsx-runtime";
import { memo as N, useCallback as m } from "react";
import { S as D } from "../../SortSelectorSelect-DSr3KYi4.js";
import { isEmpty as R, SortableContainerContext as V, SortableOverlay as k, getIndexFromID as E, SortableItem as L, getIdFromIndex as u } from "@biron-data/react-components";
import { useSelectorLayout as q } from "../../layout/useSelectorLayout.js";
import { o as y } from "../../dummyModel-DGc8qBEQ.js";
import { Row as z, Col as A } from "antd";
const U = { label: "Date" }, W = N(function({
  value: c,
  onChange: s,
  placeholder: S,
  handleDelete: b,
  handleChange: o,
  groupedOptions: e
}) {
  const a = q(), w = m(
    (r, l, t) => {
      const i = r;
      i[l].isDefault = !1, i[t].isDefault = !1, s == null || s(r);
    },
    [s]
  ), $ = m((r) => {
    if (r === void 0)
      return;
    const l = c ?? [], t = y(e, Number(r));
    s == null || s([
      ...l.map((i) => ({ ...i, isDefault: !1 })),
      {
        asc: !1,
        column: (t == null ? void 0 : t.value) ?? 0,
        isDefault: !1,
        value: t == null ? void 0 : t.label,
        id: t == null ? void 0 : t.id
      }
    ]);
  }, [c, e, s]), n = m((r, l) => {
    const t = y(e, Number(r));
    o(l, {
      asc: !1,
      column: (t == null ? void 0 : t.value) ?? 0,
      isDefault: !1,
      value: t == null ? void 0 : t.label,
      id: t == null ? void 0 : t.id
    });
  }, [e, o]), F = m((r, l) => {
    R(l) && b(r);
  }, [b]), M = m((r, l) => {
    c && o(l, {
      ...c[l],
      asc: r
    });
  }, [o, c]);
  return /* @__PURE__ */ d(j, { children: [
    c && /* @__PURE__ */ f(
      V,
      {
        value: c,
        handleChange: w,
        overlayRender: (r) => /* @__PURE__ */ f(k, { activeId: r, children: /* @__PURE__ */ f(D, { id: r, offset: 0, groupedOptions: e, value: c == null ? void 0 : c[E(r)], allowClear: !0, placeholder: S, layout: a }) }),
        children: c == null ? void 0 : c.map((r, l) => /* @__PURE__ */ f(L, { id: u(l), containerStyle: { marginBottom: 5 }, children: /* @__PURE__ */ f(D, { id: u(l), offset: 0, groupedOptions: e, value: r, allowClear: !0, placeholder: S, onChange: (t) => F(l, t), onSelect: (t) => n(t, l), onDirectionChange: (t) => M(t, l), isDefault: r.isDefault, layout: a }, `${r.column}-${l}`) }, `${r.column}-${l}`))
      }
    ),
    /* @__PURE__ */ f(z, { children: /* @__PURE__ */ f(A, { span: 24, children: /* @__PURE__ */ f(D, { offset: 1, groupedOptions: e, placeholder: S, id: (c == null ? void 0 : c.length) ?? 0, value: void 0, onChange: $, handleChange: o, layout: a }) }) })
  ] });
});
export {
  U as dateOption,
  W as default
};
//# sourceMappingURL=MultipleSortSelector.js.map
